import DOMPurify from "dompurify";

/**
 * Sanitize untrusted HTML before rendering it with dangerouslySetInnerHTML.
 * DOMPurify needs a DOM, so during static pre-rendering (no `window`) we fall
 * back to stripping script/style/iframe tags and inline event handlers.
 */
export function sanitizeHtml(html: string): string {
  if (!html) return "";

  if (typeof window !== "undefined" && typeof window.document !== "undefined") {
    return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
  }

  return html
    .replace(/<\s*(script|style|iframe|object|embed)[\s\S]*?<\s*\/\s*\1\s*>/gi, "")
    .replace(/<\s*(script|style|iframe|object|embed)\b[^>]*\/?>/gi, "")
    .replace(/\son\w+\s*=\s*(".*?"|'.*?'|[^\s>]+)/gi, "")
    .replace(/(href|src)\s*=\s*(["'])\s*javascript:[^"']*\2/gi, '$1="#"');
}
